import { Box, Text } from '@doist/marketist';
import { Image } from '../image/image';
import css from './rich-text-highlight.module.css';
export function RichTextHighlight({
  children
}: {
  children: React.ReactNode;
}) {
  return <Box className={css.richTextHighlight} data-sentry-element="Box" data-sentry-component="RichTextHighlight" data-sentry-source-file="rich-text-highlight.tsx">
            <Image src="https://images.ctfassets.net/dm4oa8qtogq0/1TgMnaLtOngK7ttOl4Vrij/7c637d97fb2d10a179f69139c50d2879/highlight-shape_2x.png" width={720} height={295} alt="" data-sentry-element="Image" data-sentry-source-file="rich-text-highlight.tsx" />
            <Text tag="blockquote" data-sentry-element="Text" data-sentry-source-file="rich-text-highlight.tsx">{children}</Text>
        </Box>;
}